import { exists } from '@/api'

export interface SystemCodeKey {
  id: number
  key: string
  name: string
  nameKana: string
  note1: string
  note2: string
  note3: string
  revision: number
}

export const defaultSystemCodeKey = (): SystemCodeKey => ({
  id: 0,
  key: '',
  name: '',
  nameKana: '',
  note1: '',
  note2: '',
  note3: '',
  revision: 0
})

export function SystemCodeKeyFromJSON(json: any): SystemCodeKey {
  return SystemCodeKeyFromJSONTyped(json)
}

export function SystemCodeKeyFromJSONTyped(json: any): SystemCodeKey {
  if (json === null || json === undefined) return json
  return {
    id: exists(json, 'id') ? json.id : 0,
    key: exists(json, 'key') ? json.key : '',
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    note1: exists(json, 'note1') ? json.note1 : '',
    note2: exists(json, 'note2') ? json.note2 : '',
    note3: exists(json, 'note3') ? json.note3 : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
